<div class="p-d-flex p-flex-column">
        <div class="p-grid">
          <div class="p-col-8 m-auto">
            <div class="p-grid">
              <div class="p-xl-7">
                <img class="img-fluid" [src]="urlImageUpload">
              </div>
              <div class="p-xl-5 p-md-12 p-d-flex p-flex-column p-jc-center">
                <h2 class="p-d-flex p-jc-center">{{noticia.titulo}}</h2>
                <p class="p-d-flex p-jc-center"> {{noticia.fechaCreacion | date :'d-M-yyyy'}}</p>
              </div>
            </div>
          </div>
          <div class="p-col-7 p-d-flex p-jc-center m-auto">
            <div [innerHtml]="noticia.body" ></div>
          </div>
        </div>
    </div>
